import React, { useEffect, useState, useRef } from 'react'
import {
  Edit,
  TextInput,
  useTranslate,
  useNotify,
  TabbedForm,
  FormTab,
  useRedirect,
  useEditController,
  BooleanInput,
  required,
  maxLength,
  ImageInput,
  ImageField,
  TabbedFormTabs
} from 'react-admin'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Grid, Skeleton, Box, CircularProgress, LinearProgress } from '@mui/material';
import { FieldArray } from './logic/ArrayInput'
import { CurrencyBase } from './logic/CurrencyBase'
import { FieldArrayProduct } from './logic/ArrayInputProduct'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { CardChildEntities } from 'src/components/uiElements/CRUD/CardChildEntities'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { paymentServices } from 'src/services/payment/Payment.service'
import { numberingServices } from 'src/services/reservation/numbering/numbering.service'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { Notification } from 'src/components/pages/administration/work-unit/logic/Notification'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { FieldArrayBanner } from './logic/ArrayInputBanner'
import { bannerServices } from 'src/services/reservation/banner/Banner.service'
import { FieldArrayLanding } from './logic/ArrayInputLanding'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_GET } from 'src/helper/Permission'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { FieldArrayDueDateMethodWorkUnit } from './logic/ArrayInputDueDateMethodWorkUnit'
import { createDueDateMethodByWorkUnit } from './logic/handleSendDueDateMethod'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'
import { useLocation } from 'react-router-dom'
import { FormBilling } from './logic/FormBilling'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import { currencyServices } from 'src/services/reservation/currency/currency.service'
import { ModalCurrencyBase } from './logic/ModalRelationCurrencyBase';
import { ArrayInputPayments } from './logic/ArrayInputPayments';
import { PaymentTypesProvider } from './logic/PaymentTypesContext';

export const WorkUnitEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const location = useLocation()
  const redirect = useRedirect()
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)
  const [paymentTypeList, setPaymentTypeList] = useState([])
  const [loadingPaymentTypeList, setLoadingPaymentTypeList] = useState(false)
  const [paymentMethodList, setPaymentMethodList] = useState([])
  const [loadingPaymentMethodList, setLoadingPaymentMethodList] = useState(false)
  const [numberingList, setNumberingList] = useState([])
  const [loadingNumberingList, setLoadingNumberingList] = useState(false)
  const [loadingDueDateMethodByWorkUnit, setLoadingDueDateMethodByWorkUnit] = useState(false)
  const [dueDateMethodByWorkUnit, setDueDateMethodByWorkUnit] = useState([])
  const [tabIndex, setTabIndex] = useState('0')
  const { record, isLoading, isFetching } = useEditController({ resource: 'work-unit', id })
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [typeError, setTypeError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [optionsCurrency, setOptionsCurrency] = useState([])
  const [openModalCurrencyBase, setOpenModalCurrencyBase] = useState(false);
  const [missingBases, setMissingBases] = useState(null);
  const [dataOriginal, setDataOriginal] = useState(null);
  const [disableEditButton, setDisableEditButton] = useState(false)
  const [disableValidation, setDisableValidation] = useState(false)

  const currencyBaseRef = useRef(null); // Referencia al componente hijo

  useEffect(()=>{
    if(disableValidation){
      const saveButton = document.getElementById('saveButtonCustom'); 
      if (saveButton) { saveButton.click(); }
    }
  },[disableValidation])

  const getAllCurrencys = async () => {
    try {
      const allCurrencys = await currencyServices.getByAll()
      if (allCurrencys) {
        setOptionsCurrency(allCurrencys)
        return
      }
      setOptionsCurrency([])
      notify(`Currencys not found`, { type: 'error' })
    } catch (error) {
      setOptionsCurrency([])
      notify(`please, refresh page`, { type: 'error' })
    }
  }


  useEffect(() => {
    const pathSegments = location.pathname.split('/')
    const currentTab = pathSegments.length > 3 ? pathSegments[pathSegments.length - 1] : '0'
    setTabIndex(currentTab)
  }, [location.pathname])

  const getDueDateMethodRelation = async (id) => {
    try {
      setLoadingDueDateMethodByWorkUnit(true)
      const dueDateMethodByWorkUnit = await dueDateServices.getDueDateMethodByWorkUnit({ work_unit_id: id })
      setDueDateMethodByWorkUnit(dueDateMethodByWorkUnit)
    } catch (error) {
      setDueDateMethodByWorkUnit([])
    } finally {
      setLoadingDueDateMethodByWorkUnit(false)
    }
  }

  const getPaymentTypeService = async () => {
    setLoadingPaymentTypeList(true)
    try {
      const allPaymentType = await paymentServices.getAllPaymentTypes()
      if (allPaymentType) {
        setPaymentTypeList(allPaymentType)
        return
      }
      notify(`applications not found`, { type: 'error' })
    } catch (error) {
      notify(`No se encontraron tipos de pagos`, { type: 'error' })
    } finally {
      setLoadingPaymentTypeList(false)
    }
  }

  const getPaymentMethodService = async () => {
    setLoadingPaymentMethodList(true)
    try {
      const allPaymentMethod = await paymentServices.getAllPaymentMethods()
      if (allPaymentMethod) {
        allPaymentMethod.forEach(
          (elem) =>
            (elem.label = `${elem.financial_entity_relation.long_name} - ${elem.card_relation.long_name}`)
        )
        setPaymentMethodList(allPaymentMethod)
        setLoadingPaymentMethodList(false)
        return
      }
      notify(`applications not found`, { type: 'error' })
      setLoadingPaymentMethodList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingPaymentMethodList(false)
    }
  }

  const getNumberingService = async () => {
    setLoadingNumberingList(true)
    try {
      const allNumbering = await numberingServices.getAll()
      if (allNumbering) {
        setNumberingList(allNumbering)
        return
      }
      notify(`applications not found`, { type: 'error' })
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
    } finally {
      setLoadingNumberingList(false)
    }
  }


  useEffect(() => {
    ; (async () => {
      await Promise.all([
        getPaymentTypeService(),
        getPaymentMethodService(),
        getNumberingService(),
        getAllCurrencys()
      ])
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (record) {
      getDueDateMethodRelation(record?.id)

      if ((record?.work_unit || record?.parent_relation) && workUnitList.length === 0) {
        setWorkUnitList([record?.work_unit || record?.parent_relation])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const getWorkUnit = async (long_name) => {
    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const createBannersByWorkUnit = async (banners) => {
    const bannersToCreate = banners.filter((elem) => elem?.banner_id && elem?.new_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.new_register
          delete elem.banner_relation
          elem.work_unit_id = record.id
          const response = await bannerServices.createBannerByWorkUnit(elem)
          return response;
        });

        const results = await Promise.all(promises);
        return results;
      } catch (error) {
        notify(`ra.notification.create_error_banner_by_work_unit`, {
          type: 'error'
        })
        return false
      }
    }

    return true
  }

  const updateBannersByWorkUnit = async (banners) => {
    const bannersToCreate = banners.filter(elem => elem.update_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.update_register
          delete elem.banner_relation
          delete elem._id
          const response = await bannerServices.updateBannerByWorkUnit(elem)
          return response;
        });

        const results = await Promise.all(promises);
        return results;
      } catch (error) {
        notify(`ra.notification.update_error_banner_by_work_unit`, {
          type: 'error'
        })
        return false
      }
    }
    return true
  }

  const onSuccess = async (data) => {
    try {
      const promises = [
        await createBannersByWorkUnit(data.banner_relation),
        await updateBannersByWorkUnit(data.banner_relation),
        await createDueDateMethodByWorkUnit(data.due_date_method_relation, data?.id),
      ]

      await Promise.all(promises);

    } catch (error) {

    } finally {
      notify('ra.notification.updated_success_femenine', {
        type: 'success',
        messageArgs: { element: translate('ra.single_entity.work-unit') },
      })
      redirect('/work-unit')
    }
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.work-unit') },
    })
  }

  const isLoadingTab = (name) => {
    return (
      <Box display={'flex'} alignItems={'center'}>
        <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
        {translate(`ra.field.${name}`)}
      </Box>
    )
  }

  const validateCurrencyRelations = (currencyBaseRelations, setErrorMessage, setOpenErrorModal, setTypeError) => {
    const seenCombinations = new Set();
    for (const currencyRelation of currencyBaseRelations) {
      if (
        !currencyRelation.currency_from_relation.short_name ||
        !currencyRelation.currency_to_relation.short_name ||
        !currencyRelation.bases.length ||
        currencyRelation.value == null ||
        currencyRelation.value === ''
      ) {
        setErrorMessage(translate('ra.validation.errorCreatingBases'));
        setOpenErrorModal(true);
        setTypeError('empty_fields');
        return false;
      }
    }
    for (const currencyRelation of currencyBaseRelations) {
      if (Number(currencyRelation.value) <= 0) {
        setErrorMessage(translate('ra.validation.errorCreatingBasesValues'));
        setOpenErrorModal(true);
        setTypeError('value_greater_than_zero');
        return false;
      }
    }
    for (const currencyRelation of currencyBaseRelations) {
      const { currency_from_relation, currency_to_relation, bases } = currencyRelation;

      for (const base of bases) {
        const combinationKey = `${currency_from_relation.short_name}-${currency_to_relation.short_name}-${base.name}`;
        const reverseCombinationKey = `${currency_to_relation.short_name}-${currency_from_relation.short_name}-${base.name}`;
        if (seenCombinations.has(combinationKey) || seenCombinations.has(reverseCombinationKey)) {
          setErrorMessage(translate('ra.validation.errorCreatingBasesUniqueCombinations'));
          setOpenErrorModal(true);
          setTypeError('duplicate_combination');
          return false;
        }
        seenCombinations.add(combinationKey);
        seenCombinations.add(reverseCombinationKey);
      }
    }
    return true;
  };

  function validateCurrencyRelationsBase(data, response, currencyBases) {
    const missingRelations = [];
    const missingBases = [];

    const currencyRelations = new Map();
    const baseCoverage = new Map();

    const currencyMap = new Map(optionsCurrency.map(currency => [currency.id, currency]));
    if(record.currency_relation.length === 0){
      return { valid: true };
    }
    data.currency_relation.forEach(relation => {
      if (!relation.is_reverse) {
        const currencyRelationShortName = relation.currency_relation?.short_name || currencyMap.get(relation.currency_id).short_name;
        const currencyToRelationShortName = relation.currency_to_relation?.short_name || currencyMap.get(relation.currency_to_id).short_name;
        const key = `${currencyRelationShortName}-${currencyToRelationShortName}`;
        currencyRelations.set(key, relation);
        baseCoverage.set(key, new Set());
      }
    });

    response.data.forEach(entry => {
      const key = `${entry.currency_from_relation.short_name}-${entry.currency_to_relation.short_name}`;
      if (!currencyRelations.has(key)) {
        missingRelations.push({
          from: entry.currency_from_relation.short_name,
          to: entry.currency_to_relation.short_name
        });
      } else {
        entry.bases.forEach(base => {
          baseCoverage.get(key).add(base.name);
        });
      }
    });

    const groupedMissingBases = {};

    currencyRelations.forEach((_, key) => {
      const coveredBases = baseCoverage.get(key) || new Set();
      const missingForRelation = currencyBases
        .filter(base => !coveredBases.has(base.name))
        .map(base => base.name);

      if (missingForRelation.length > 0) {
        const [from, to] = key.split('-');
        if (!groupedMissingBases[key]) {
          groupedMissingBases[key] = {
            from,
            to,
            missingBases: []
          };
        }
        groupedMissingBases[key].missingBases = missingForRelation;
      }
    });

    const formattedMissingBases = Object.values(groupedMissingBases);
    if (formattedMissingBases.length > 0) {
      return {
        valid: false,
        missingBases: formattedMissingBases
      };
    }

    return { valid: true };
  }

  const transform = (data) => {
    if (hasPermissionFunction('billing', 'config')) {
      setDataOriginal(data);
      let updatedCurrencyBaseRelations = currencyBaseRef.current?.getCurrencyBaseRelationsState();

      let isValid = false
      if (!updatedCurrencyBaseRelations) {
        isValid = true
      } else {
        isValid = validateCurrencyRelations(
          updatedCurrencyBaseRelations,
          setErrorMessage,
          setOpenErrorModal,
          setTypeError
        );
      }
      if (!isValid) return null;
      const updatePromise = updatedCurrencyBaseRelations
        ? billingFormServices.updateCurrencyBaseRelation(record?.id, updatedCurrencyBaseRelations.map((currencyRelation) => ({
          currency_from: currencyRelation.currency_from_relation.short_name,
          currency_to: currencyRelation.currency_to_relation.short_name,
          value: typeof currencyRelation.value === 'number'
            ? parseFloat(currencyRelation.value.toFixed(2))
            : parseFloat(currencyRelation.value.replace(/\./g, '').replace(',', '.')),
          bases: currencyRelation.bases.map((base) => base.name),
          work_unit_hash: currencyRelation.work_unit_hash,
          is_inherited: currencyRelation.is_inherited
        })))
        : Promise.resolve(); // Si es undefined, pasar directamente a getCurrencyBaseRelations

      return updatePromise
        .then(() => {
          // Obtener las relaciones actualizadas
          let query = `work_unit_hash=${record?.hash_work_unit}`;
          return billingFormServices.getCurrencyBaseRelations(query);
        })
        .then(response => {
          /* const currencyBases = Array.from(new Set([data.billing_default_base, ...(data.billing_alternate_base.options || [])])).map((name, index) => ({ id: index, name }));

          const validationResultBase = validateCurrencyRelationsBase(data, response, currencyBases)

          if (!validationResultBase.valid && !disableValidation) {
            setMissingBases(validationResultBase.missingBases)
            setOpenModalCurrencyBase(true);
            return null;
          } else  */{
            let obj = {
              ...data,
              parent_id: data.parent?.id || null
            }
            delete obj.parent

            if (data?.currency_relation?.length > 0) {
              obj.currency_relation = data.currency_relation.map((currencyItem) => {
                // Verificar y asignar `currency_id` si no existe o es undefined
                if (currencyItem.currency_id === undefined) {
                  currencyItem.currency_id = currencyItem.currency_relation?.id;
                }

                // Verificar y asignar `currency_to_id` si no existe o es undefined
                if (currencyItem.currency_to_id === undefined) {
                  currencyItem.currency_to_id = currencyItem.currency_to_relation?.id;
                }

                // Retornar el objeto modificado de currency_relation
                return currencyItem;
              });
            }

            if (data?.landing_relation?.length > 0) {
              obj?.landing_relation?.forEach(elem => {
                elem.landing_id = elem.landing_id || elem.landing_relation?.id
                delete elem.landing_relation
              })
            }

            if (data?.banner_relation?.length > 0) {
              obj?.banner_relation?.forEach(elem => {
                elem.banner_id = elem.banner_id || elem.banner_relation?.id
                delete elem.banner_relation
              })
            }
            if (data?.due_date_method_relation?.length > 0) {
              obj?.due_date_method_relation?.forEach((elem) => {
                elem.due_date_method_id = elem?.due_date_method_id?.id
              })
            }

            if (!obj?.smtp_config) {
              obj.smtp_config = {
                transport: null,
                mailer_from: null,
                mailer_host: null,
                mailer_port: null,
                mailer_user: null,
                mailer_password: null,
                use_tls: false,
                use_ssl: false,
              }
            }
            return obj
          }
        })
        .catch(error => {
          return null;
        });
    }
    else {
      let obj = {
        ...data,
        parent_id: data.parent?.id || null
      }
      delete obj.parent

      if (data?.currency_relation?.length > 0) {
        obj.currency_relation = data.currency_relation.map((currencyItem) => {
          // Verificar y asignar `currency_id` si no existe o es undefined
          if (currencyItem.currency_id === undefined) {
            currencyItem.currency_id = currencyItem.currency_relation?.id;
          }

          // Verificar y asignar `currency_to_id` si no existe o es undefined
          if (currencyItem.currency_to_id === undefined) {
            currencyItem.currency_to_id = currencyItem.currency_to_relation?.id;
          }

          // Retornar el objeto modificado de currency_relation
          return currencyItem;
        });
      }

      if (data?.landing_relation?.length > 0) {
        obj?.landing_relation?.forEach(elem => {
          elem.landing_id = elem.landing_id || elem.landing_relation?.id
          delete elem.landing_relation
        })
      }

      if (data?.banner_relation?.length > 0) {
        obj?.banner_relation?.forEach(elem => {
          elem.banner_id = elem.banner_id || elem.banner_relation?.id
          delete elem.banner_relation
        })
      }
      if (data?.due_date_method_relation?.length > 0) {
        obj?.due_date_method_relation?.forEach((elem) => {
          elem.due_date_method_id = elem?.due_date_method_id?.id
        })
      }

      if (!obj?.smtp_config) {
        obj.smtp_config = {
          transport: null,
          mailer_from: null,
          mailer_host: null,
          mailer_port: null,
          mailer_user: null,
          mailer_password: null,
          use_tls: false,
          use_ssl: false,
        }
      }
      return obj
    }
  }


  return (
    <Edit
      {...props}
      transform={transform}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
    >
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <CardCommon title={translate('ra.title.update_workUnit')}>
            <TabbedForm
              toolbar={<CardCrudBottomButtons btnSave={true} loading={isLoading || isFetching} />}
              tabs={<TabbedFormTabs variant='scrollable' scrollButtons='auto' />}
              record={{ ...record, due_date_method_relation: dueDateMethodByWorkUnit }}
            >
              <FormTab label={translate('ra.field.main')}>
                <Grid container spacing={3}>
                  <EditInputsWrap label={translate('ra.field.id')}>
                    <TextInput disabled source='id' label={false} fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.short_name')} required>
                    <TextInput
                      source='short_name'
                      label={false}
                      fullWidth
                      validate={[
                        required(),
                        maxLength(40, translate('ra.validation.maxCharacters', { characters: 40 })),
                      ]}
                    />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.long_name')} required>
                    <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.description')} required>
                    <TextInput source='description' label={false} fullWidth validate={[required()]} />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.logo')}>
                    <ImageInput source='logo' label={''} className='image-input'>
                      <ImageField source='src' title='title' />
                    </ImageInput>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.logo_voucher')}>
                    <ImageInput source='logo_voucher' label={''} className='image-input'>
                      <ImageField source='src' title='title' />
                    </ImageInput>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.parent_workunit')}>
                    <AutocompleteInput
                      source='parent'
                      options={workUnitList}
                      loading={loadingWorkUnitList}
                      optionsText={['long_name']}
                      onSearch={getWorkUnit}
                      resetOnLoad={false}
                      defaultValue={record?.work_unit || record?.parent_relation || null}
                    />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.payment_types')}>
                    {loadingPaymentTypeList ? (
                      <Skeleton variant='rectangular' width={'100%'} height={40} />
                    ) : (
                      <SelectInput
                        size='small'
                        optionsText={['long_name']}
                        fullWidth
                        label={false}
                        source='payment_type'
                        defaultValue={record?.payment_type}
                        options={paymentTypeList}
                        multiple
                      />
                    )}
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.payment_methods')}>
                    {loadingPaymentMethodList ? (
                      <Skeleton variant='rectangular' width={'100%'} height={40} />
                    ) : (
                      <SelectInput
                        size='small'
                        optionsText={['label']}
                        fullWidth
                        label={false}
                        source='payment_method'
                        defaultValue={record?.payment_method}
                        options={paymentMethodList}
                        multiple
                      />
                    )}
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.numbering_client')} required>
                    {loadingNumberingList ? (
                      <Skeleton variant='rectangular' width={'100%'} height={40} />
                    ) : (
                      <SelectInput
                        size='small'
                        optionsText={['long_name']}
                        fullWidth
                        label={false}
                        source='client_numbering_id'
                        defaultValue={record?.client_numbering_id}
                        options={numberingList}
                        validate={[required()]}
                      />
                    )}
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.numbering_reservation')} required>
                    {loadingNumberingList ? (
                      <Skeleton variant='rectangular' width={'100%'} height={40} />
                    ) : (
                      <SelectInput
                        size='small'
                        optionsText={['long_name']}
                        fullWidth
                        label={false}
                        source='reservation_numbering_id'
                        defaultValue={record?.reservation_numbering_id}
                        options={numberingList}
                        validate={[required()]}
                      />
                    )}
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.json')} xs={12} md={6} lg={4}>
                    <JsonInput source='config' width='auto' />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.url')}>
                    <TextInput source='url' label='' fullWidth />
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.state')}>
                    <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
                  </EditInputsWrap>
                </Grid>
              </FormTab>
              <FormTab
                label={isLoading || isFetching ? isLoadingTab('currency') : translate('ra.field.currency')}
                disabled={isLoading || isFetching}
              >
                {tabIndex == 1 ? (
                  <Grid container spacing={3}>
                  <FieldArray editMode />
                </Grid>
              ) : (
                <LinearProgress style={{ width: '100%' }} />
              )}
            </FormTab>
            {hasPermissionFunction('billing', 'config') && (
                <FormTab
                  label={isLoading || isFetching ? isLoadingTab('base') : translate('ra.field.base')}
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 2 ? (
                    <Grid container spacing={0} >
                      <CurrencyBase editMode workUnitId={record?.id} infoWorkUnit={record} ref={currencyBaseRef} />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}

              <FormTab
                label={isLoading || isFetching ? isLoadingTab('product') : translate('ra.field.product')}
                disabled={isLoading || isFetching}
              >

                {tabIndex == 3 ? (
                  <Grid container spacing={3}>
                    <FieldArrayProduct />
                  </Grid>
                ) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>
              {hasPermissionFunction('banner', PERMISSION_GET) && (
                <FormTab
                  label={isLoading || isFetching ? isLoadingTab('banner') : translate('ra.field.banner')}
                  disabled={isLoading || isFetching}
                >

                  {tabIndex == 4 ? (
                    <Grid container spacing={3}>
                      <FieldArrayBanner />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              {hasPermissionFunction('due-date-method', PERMISSION_GET) && (
                <FormTab
                  label={
                    loadingDueDateMethodByWorkUnit
                      ? isLoadingTab('expirations')
                      : translate('ra.field.expirations')
                  }
                  disabled={loadingDueDateMethodByWorkUnit}
                >

                  {tabIndex == 5 ? (
                    <Grid container spacing={3}>
                      <FieldArrayDueDateMethodWorkUnit
                        editMode={true}
                        work_unit_id={id || record?.id}
                        record={record}
                      />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              {hasPermissionFunction('landing', PERMISSION_GET) && (
                <FormTab
                  label={isLoading || isFetching ? isLoadingTab('landing') : translate('ra.field.landing')}
                  disabled={isLoading || isFetching}
                >

                  {tabIndex == 6 ? (
                    <Grid container spacing={3}>
                      <FieldArrayLanding />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}

              {hasPermissionFunction('product-payment-by-work-unit', 'revision') && (
                <FormTab
                  label={
                    isLoading || isFetching ? isLoadingTab('payments') : translate('ra.field.payments')
                  }
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 7 ? (
                    <Grid container spacing={3}>
                      <PaymentTypesProvider>
                        <ArrayInputPayments workUnitId = {record?.id}/>
                      </PaymentTypesProvider>
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              <FormTab
                label={
                  isLoading || isFetching ? isLoadingTab('notification') : translate('ra.field.notification')
                }
                disabled={isLoading || isFetching}
              >
                {tabIndex == 8 ? (
                  <Grid container spacing={3}>
                    <Notification editMode />
                  </Grid>
                ) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>
              {hasPermissionFunction('billing', 'config') && (
                <FormTab
                  label={isLoading || isFetching ? isLoadingTab('billing') : translate('ra.field.billing')}
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 9 ? (<FormBilling record={record} />) : <LinearProgress style={{ width: '100%' }} />}
                </FormTab>
              )}
            </TabbedForm>
          </CardCommon>
        </Grid>
        <Grid item xs={4}>
          {/* <BookAuthor /> */}

          {isLoading || isFetching ? (
            <Skeleton variant='rectangular' width={'100%'} height={400} />
          ) : (
            <CardChildEntities recordContext={record?.children} />
          )}
        </Grid>
      </Grid>

      {/* Agrega el modal de error aquí */}
      <Dialog open={openErrorModal} onClose={() => {
        setOpenErrorModal(false);
        setErrorMessage('');
      }}>
        <DialogTitle>Atención</DialogTitle>
        <DialogContent>
          <DialogContentText>{errorMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenErrorModal(false);
            setErrorMessage('');
          }} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        maxWidth="lg"
        fullWidth
        open={openModalCurrencyBase}
        onClose={() => {
          setOpenModalCurrencyBase(false);
          setMissingBases(null);
        }}
      >
        {/* Renderiza el componente hijo dentro del Dialog */}
        <ModalCurrencyBase
          onClose={() => {
            setOpenModalCurrencyBase(false);
            setMissingBases(null);
          }}
          onCloseWithoutvalidate = {
            ()=>{
              setOpenModalCurrencyBase(false);
              setMissingBases(null);
              setDisableValidation(true)
            }
          }
          workUnitId={record?.id}
          infoWorkUnit={record}
          missingBases={missingBases}
          allCurrencies={optionsCurrency}
        />
      </Dialog>

    </Edit>
  )
}
